"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lite = _interopRequireDefault(require("algoliasearch/lite"));

var _helpers = require("utils/helpers");

var SearchPanel = /*#__PURE__*/function () {
  function SearchPanel(component) {
    (0, _classCallCheck2["default"])(this, SearchPanel);
    this.dom = {
      $component: component,
      $close: Array.from(document.querySelectorAll('.js-search-panel-close')),
      $headerShow: Array.from(document.querySelectorAll('.js-header-show-search-panel')),
      $content: component.querySelector('.js-search-panel-ajax-content'),
      $form: component.querySelector('.js-search-panel-form'),
      $searchInput: component.querySelector('.js-search-panel-input'),
      $searchResults: component.querySelector('.js-search-panel-results'),
      $searchSuggestions: Array.from(component.querySelectorAll('.js-search-panel-suggestions a')),
      $searchSuggestionsContainer: component.querySelector('.SearchPanel__suggestions'),
      $searchProductsContainer: component.querySelector('.ProductCalloutGrid'),
      $searchNoResultsContainer: component.querySelector('.SearchPanel__noresults')
    }, this.state = {
      open: false,
      animating: false,
      loading: false,
      requiredReload: false,
      sort: 'featured',
      openDuration: 500,
      closeDuration: 750,
      activeClass: 'is-active',
      parser: new DOMParser(),
      isShitBrowser: (0, _helpers.isOldIE)(),
      client: (0, _lite["default"])(component.dataset.app_id, component.dataset.search_api_key),
      index: null,
      blankCartItem: null,
      timeout: false
    };
    this.toggleHandler = this.toggle.bind(this);
    this.keydownHandler = this.onKeydown.bind(this);
    this.clickHandler = this.close.bind(this);
    this.formHandler = this.search.bind(this);
    this.inputHandler = this.inputSearch.bind(this);
    this.suggestoionHandler = this.suggestionClick.bind(this);
    this.mount(); //to remove:
    //this.toggle();
  }

  (0, _createClass2["default"])(SearchPanel, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('SearchPanel : mount', this);
      state.index = state.client.initIndex(dom.$component.dataset.index_name);
      state.blankCartItem = dom.$component.querySelector('.js-search-panel-card-blank');
      dom.$component.querySelector('.js-search-panel-card-blank').remove();
      document.addEventListener('keydown', this.keydownHandler);
      dom.$close.forEach(function ($element) {
        return $element.addEventListener('click', _this.clickHandler);
      });
      dom.$form.addEventListener('submit', this.formHandler);
      dom.$searchInput.addEventListener('input', this.inputHandler);
      console.log((0, _helpers.isOldIE)());
      console.log(dom.$searchSuggestions);

      if (dom.$searchSuggestions) {
        dom.$searchSuggestions.forEach(function ($element) {
          return $element.addEventListener('click', _this.suggestoionHandler);
        });
      }

      if (!state.isShitBrowser) {
        dom.$headerShow.forEach(function ($element) {
          return $element.addEventListener('click', _this.toggleHandler);
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this2 = this;

      var self = this;
      var dom = this.dom;
      console.log('SearchPanel : unmount', this);
      dom.$headerShow.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.toggleHandler);
      });
      document.removeEventListener('keydown', this.keydownHandler);
      dom.$close.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.clickHandler);
      });
      dom.$form.removeEventListener('submit', this.formHandler);
      dom.$searchInput.removeEventListener('input', this.inputHandler);

      if (dom.$searchSuggestions) {
        dom.$searchSuggestions.forEach(function ($element) {
          return $element.removeEventListener('click', _this2.suggestoionHandler);
        });
      }
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var dom = this.dom,
          state = this.state;
      console.log('SearchPanel : toggle', this);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "inputSearch",
    value: function inputSearch(event) {
      var dom = this.dom,
          state = this.state;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      console.log('SearchPanel : inputSearch', this);
      var t = this;
      clearTimeout(state.timeout);
      state.timeout = setTimeout(function () {
        t.search();
      }, 200);
    }
  }, {
    key: "search",
    value: function search(event) {
      var dom = this.dom,
          state = this.state;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      console.log('SearchPanel : search', this);
      dom.$searchResults.innerHTML = '';

      if (dom.$searchInput.value) {
        state.index.search(dom.$searchInput.value).then(function (_ref) {
          var hits = _ref.hits;

          if (hits.length > 0) {
            hits.forEach(function (searchItem) {
              var newCard = state.blankCartItem.cloneNode(true);
              newCard.querySelectorAll('.ProductCard__title').forEach(function (div) {
                div.innerHTML = searchItem.title;
              });
              newCard.querySelectorAll('.ProductCard__price-value').forEach(function (div) {
                div.innerHTML = searchItem.price;
              });
              newCard.querySelectorAll('.ProductCard__link').forEach(function (div) {
                div.href = '/products/' + searchItem.handle;
              });
              newCard.querySelectorAll('.Media__object').forEach(function (div) {
                div.dataset.src = searchItem.image;
                div.style.backgroundImage = 'url(' + searchItem.image + ')';
              });
              newCard.addEventListener('click', document.documentElement.classList.remove('disable-scroll'));
              dom.$searchResults.appendChild(newCard);
            });
            dom.$searchSuggestionsContainer.classList.remove('active');
            dom.$searchProductsContainer.classList.add('active');
            dom.$searchNoResultsContainer.innerHTML = dom.$searchNoResultsContainer.dataset.content;
          } else {
            dom.$searchSuggestionsContainer.classList.add('active');
            dom.$searchProductsContainer.classList.remove('active');
            dom.$searchNoResultsContainer.innerHTML = dom.$searchNoResultsContainer.dataset.noresults;
          }
        })["catch"](function (err) {
          console.log(err);
          dom.$searchSuggestionsContainer.classList.add('active');
          dom.$searchProductsContainer.classList.remove('active');
          dom.$searchNoResultsContainer.innerHTML = dom.$searchNoResultsContainer.dataset.noresults;
        });
      } else {
        dom.$searchSuggestionsContainer.classList.add('active');
        dom.$searchProductsContainer.classList.remove('active');
        dom.$searchNoResultsContainer.innerHTML = dom.$searchNoResultsContainer.dataset.content;
      }
    }
  }, {
    key: "suggestionClick",
    value: function suggestionClick(event) {
      var self = this;
      var dom = this.dom,
          state = this.state;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      console.log('SearchPanel : suggestionClick', this);
      dom.$searchInput.value = event.target.innerHTML;
      this.search();
    }
  }, {
    key: "open",
    value: function open() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('SearchPanel : open', this);

      if (!state.animating) {
        state.animating = true;
        dom.$component.setAttribute('aria-hidden', false);
        document.documentElement.classList.add('disable-scroll');
        dom.$searchInput.focus();
        setTimeout(function () {
          dom.$component.classList.add(state.activeClass);
          dom.$headerShow.forEach(function ($element) {
            return $element.classList.add(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          state.open = true;
          state.animating = false;
          self.notify('open');
        }, state.openDuration);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('SearchPanel : close', this);

      if (!state.animating) {
        state.animating = true;
        document.documentElement.classList.remove('disable-scroll');
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
          dom.$headerShow.forEach(function ($element) {
            return $element.classList.remove(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          dom.$component.setAttribute('aria-hidden', true);
          state.open = false;
          state.animating = false;
          self.notify('close');
        }, state.closeDuration);
      }
    }
  }, {
    key: "notify",
    value: function notify(action) {
      var dom = this.dom,
          state = this.state;
      console.log('SearchPanel : notify', this);
      var SearchPanelEvent = new CustomEvent("SearchPanel:".concat(action));
      document.dispatchEvent(SearchPanelEvent);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var dom = this.dom,
          state = this.state;
      console.log('SearchPanel : onKeydown', this, event);
      var escape = event.keyCode === 27;
      var enter = event.keyCode === 13;

      if (state.open && escape) {
        this.close();
      }

      if (state.open && enter) {
        clearTimeout(state.timeout);
        dom.$searchInput.blur();
        this.search();
      }
    }
  }]);
  return SearchPanel;
}();

exports["default"] = SearchPanel;